<template>
  <!-- Credit Card Number -->
  <div class="form-group inner-addon2">
    <label for="card_number">{{ props.text }}</label>
    <input
      id="card_number"
      v-model="card_number"
      autocomplete="cc-number"
      data-lpignore="true"
      name="card_number"
      type="tel"
      @blur="onBlur"
      @focus="onFocus"
      :class="{error: props.valid.$errors.length}"
    />
    <img id="cc" v-if="getBrandImage" :src="getBrandImage" :alt="props.text" />
    <span v-if="props.valid.$errors.length" class="error-message">
        {{ props.valid.$errors[0].$message }}
    </span>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import Payment from 'payment'
import { onBlur, onFocus } from './fields.js'

const props = defineProps({
  text: String,
  icons: Object,
  valid: Object,
})

const emit = defineEmits(['change'])

const card_number = ref(null)

watch(card_number, async (newNumber) => {
    emit('change', card_number.value);
    card_number.value = Payment.fns.formatCardNumber(newNumber);
})


const getBrandImage = computed(() => {
  const images = props.icons;
  const brand = Payment.fns.cardType(card_number.value) || 'unknown';
  const filtered = images?.filter((image) => image.brand === brand);
  let image = '';

  if (filtered && filtered.length > 0) {
    image = filtered[0].icon;
  } else {
    const unknownImage = images?.filter((image) => image.brand === 'unknown');
    if (unknownImage && unknownImage.length > 0) {
      image = unknownImage[0].icon;
    }
  }

  return image;
});
</script>